export default __webpack_public_path__ + "static/media/(4)-BDIT4DA-Tutorial-HPCS2019.23325cd4.md";